import {Dictionary, DictionaryCode, DictionaryEntry} from '../shared/model/Dictionary';

export const DictionaryHelper = {
  getDictionaryByCode: (dictionaries: Dictionary[], code: DictionaryCode): DictionaryEntry[] =>
    dictionaries.find(value => value.code === code)?.entries ?? []
};